import React, { useEffect, useState } from 'react';
import { CalendarOutlined, LoadingOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import moment from 'moment';
import passService from '../../../services/pass/pass.service';
import SimpleNotFoundComponent from '../../../helpers/components/simple_not_found.component';
import PassDetail from './pass_detail';

const PassLayout = ({ pass_code }) => {
    const [state, setState] = useState({
        loading: true,
        pass: null,
        is_expired: false,
        is_checked_in: false,
    });

    const fetchPass = async () => {
        setState(state => ({ ...state, loading: true }));
        const passResponse = await passService.getPass(pass_code);
        const pass = passResponse?.pass ?? null;
        const is_checked_in = passResponse?.is_checked_in ?? false;

        const is_expired = pass ? moment().startOf('day').diff(moment(pass.period_pass?.end_date).startOf('day'), 'days') > 0 : false;

        setTimeout(() => {
            setState(state => ({ ...state, pass, is_expired, is_checked_in, loading: false }));
        }, 500);
    }

    useEffect(() => {
        fetchPass();
    }, []);

    return (
        <>
            <div className='mobile-padding-24'>
                {
                    state?.loading ?
                    (
                        <LoadingOutlined style={{ fontSize: 20 }} />
                    )
                    :
                    (
                        <>
                            {
                                state?.pass ?
                                (
                                    <>
                                        <div>
                                            <div style={{ display: 'flex' }}>
                                                <Space style={{ justifyContent: 'start', width: '100%' }} size={12}>
                                                    <div style={{ height: 60, width: 60, background: '#fff', borderRadius: 6 }}>
                                                        <div style={{ background: 'var(--main-color)', height: 6, borderRadius: '6px 6px 0 0' }} />
                                                        <div style={{
                                                            height: '100%',
                                                            padding: '6px 4px',
                                                            textAlign: 'center',
                                                            border: '1px solid #cbd5e0',
                                                            borderTop: 'none',
                                                            borderBottomLeftRadius: 6,
                                                            borderBottomRightRadius: 6,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}>
                                                            <CalendarOutlined style={{ fontSize: 24, color: 'var(--main-color)' }} />
                                                        </div>
                                                    </div>

                                                    <div style={{ textAlign: 'left' }}>
                                                        <div>
                                                            <span style={{ color: '#6f7287', fontWeight: 500 }}>
                                                                <Space wrap size={2}>
                                                                    <span>Pass Code:</span>
                                                                    <span>{state?.pass?.pass_code}</span>
                                                                </Space>
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span style={{ color: '#6f7287', fontWeight: 500 }}>
                                                                <Space wrap size={2}>
                                                                    <span>Valid:</span>
                                                                    <span>{moment(state?.pass?.period_pass?.start_date).format("DD MMM YYYY")} – {moment(state?.pass?.period_pass?.end_date).format("DD MMM YYYY")}</span>
                                                                </Space>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </Space>
                                            </div>
                                        </div>

                                        <div style={{ marginTop: 24 }}>
                                            <PassDetail pass={state?.pass} is_expired={state?.is_expired} is_checked_in={state?.is_checked_in} onRefresh={fetchPass} />
                                        </div>
                                    </>
                                )
                                :
                                (
                                    <SimpleNotFoundComponent
                                        isBack
                                        title={'Pass Not Found'}
                                        description={`Pass ${pass_code} not found`}
                                    />
                                )
                            }
                        </>
                    )
                }
            </div>
        </>
    );
}

export default PassLayout;
